import React, { useRef, useEffect } from "react";
import teamTrustLogo from "../../assets/images/team-trust-logo.png";
import UserMenu from "../../components/ui/icons/UserMenu";
import Notifications from "../../components/ui/icons/Notifications";
import MiniMenu from "../../components/ui/icons/MiniMenu";
import useOrganization from "../../features/organization/hooks/useOrganization";
import { useProfile } from "../../features/auth/hooks/useProfile";

export const useClickOutside = (cb: () => void) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const h = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) cb();
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [cb]);
  return ref;
};

const Header: React.FC = () => {
  const { currentOrganization } = useOrganization();
  const { isAuthenticated } = useProfile();
  return (
    <>
      <header
        className="
          flex items-stretch w-full sticky top-0 z-[100] flex-shrink-0 bg-white border-b-2 border-[#f5f6f9] h-[60px] md:h-[72px] xl:h-[82px] sidebar:shadow-[0_2px_14px_#0000001a]"
      >
        <div
          className="
            flex items-center flex-shrink-0 px-3 sm:px-4 md:px-6 xl:px-7"
        >
          <img
            src={currentOrganization?.image ?? teamTrustLogo}
            alt="team-trust-logo"
            className="object-contain h-12 sm:h-12 md:h-16 xl:h-[70px]"
          />
        </div>

        <div className="flex-1" />

        <div className="flex items-stretch flex-shrink-0 overflow-visible">
          {isAuthenticated && (
            <>
              <div className="flex items-center px-2 sm:px-3 md:px-4 sidebar:hidden relative overflow-visible">
                <UserMenu avatarClass="w-9 h-9 sm:w-10 sm:h-10 md:w-11 md:h-11" />
              </div>
              <Notifications />
              <MiniMenu />
            </>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
